import {
    Breadcrumb,
    Image,
    Col,
    Row,
    Form,
    Button,
    Upload,
    message,
    Modal,
    Input,
    Divider,
    Space,
    Descriptions,
    Tag
} from "antd"
import {Link} from "react-router-dom"
import {EditOutlined, EyeOutlined} from "@ant-design/icons";
import {DashboardOutlined, UserOutlined, UploadOutlined, SyncOutlined} from "@ant-design/icons"
import {BsKey} from "react-icons/bs";
import {useContext, useEffect, useMemo, useRef, useState} from "react";
import Header from "../../components/dashboard/header"
import {userStore} from "../../store/userStore";
import {useFetchSignature, useUpdatePassword, useUploadSignature} from "../../hooks/user/userQuery";
import {extractValueFromInputRef} from "../../helpers/dom";
import Placeholder from "../../assets/placeholder.png"
import { SERVER_URL } from "../../defaults/utilities";


export default function Profile() {
    const [flag,setFlag] = useState(false);
    const [isPrevShow,setPrevShow] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const handleOpenModal = () => setIsOpen(true);
    const handleModalClose = () => setIsOpen(false);

    const user = userStore(state => state.user);


    const oldPasswordRef = useRef(null);
    const newPasswordRef = useRef(null);
    const confirmPasswordRef = useRef(null);

    const [sig, setSigData] = useState("")

    const fetchSignature = useFetchSignature()


    const uploadSignature = useUploadSignature()
    const updatePassword = useUpdatePassword();

    useEffect(() => {
        if(user?.userId){
            const signature = `${SERVER_URL}/signature/fetch/${user.userId}`
            setSigData(signature)
        }
    }, [user]);



    const handleSignatureUpload = async ({file, onSuccess}) => {
        setTimeout(() => {
            (async () => {
                const formData = new FormData();
                formData.append("file", file)
                const response = await uploadSignature(formData);
                message.success("Signature uploaded successfully");
                setFlag(!flag)
            })().finally(() => onSuccess("ok"))
        }, 0);
    }


    const handleUpdatePassword = async () => {
        const payload = {
            oldPassword: extractValueFromInputRef(oldPasswordRef),
            newPassword: extractValueFromInputRef(newPasswordRef),
            confirmPassword: extractValueFromInputRef(confirmPasswordRef),
            userId: user.userId
        }
        await updatePassword(payload);
        message.success("password updated successfully");
        setIsOpen(false);
        setFlag(!flag)
    }


    return (
        <>
            <div className="main-container" style={{ background: '#f0f2f5', minHeight: '100vh' }}>
                <Header/>
                <div className="main-body" style={{ padding: '24px' }}>
                    <div className="info-bar" style={{ marginBottom: '24px' }}>
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <DashboardOutlined className="dashboard-icon"/>
                                <Link to={"/dashboard"}>Dashboard</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <UserOutlined/>
                                <Link to={"/dashboard/profile"}>Profile</Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <div className="profile-section" style={{
                        background: 'linear-gradient(to bottom, white, #fafafa)',
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                        padding: '40px',
                        transition: 'all 0.3s ease',
                        border: '1px solid rgba(0,0,0,0.06)'
                    }}>
                        <Row justify={'center'} gutter={[32, 32]}>
                            <Col xs={24} md={8}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '24px'
                                }}>
                                    <div style={{
                                        borderRadius: '50%',
                                        overflow: 'hidden',
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                        border: '4px solid white',
                                        position: 'relative',
                                        background: 'linear-gradient(45deg, #f0f0f0, #ffffff)',
                                        padding: '4px'
                                    }}>
                                        <Image
                                            className="image-placeholder"
                                            width={200}
                                            height={200}
                                            style={{ objectFit: 'cover' }}
                                            src={Placeholder}
                                        />
                                    </div>
                                    <Upload
                                        beforeUpload={(file) => {
                                            const isPNG = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg';
                                            if (!isPNG) {
                                                message.error(`${file.name} is not a png/jpg/jpeg file`);
                                            }
                                            return isPNG || Upload.LIST_IGNORE;
                                        }}
                                    >
                                        <Button
                                            type="primary"
                                            style={{
                                                background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                                                border: 'none',
                                                borderRadius: '6px',
                                                height: '40px',
                                                boxShadow: '0 2px 4px rgba(24,144,255,0.35)'
                                            }}
                                        >
                                            <UploadOutlined />
                                            Update Profile Picture
                                        </Button>
                                    </Upload>
                                </div>
                            </Col>
                            <Col xs={24} md={16}>
                                <div style={{
                                    background: 'linear-gradient(145deg, #ffffff, #f8f9fa)',
                                    borderRadius: '12px',
                                    padding: '24px',
                                    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                                    border: '1px solid rgba(0,0,0,0.04)'
                                }}>
                                    <Descriptions
                                        column={{ xs: 1, sm: 2 }}
                                        layout="vertical"
                                        bordered
                                        labelStyle={{
                                            fontWeight: 500,
                                            color: '#1f1f1f',
                                            background: 'rgba(0,0,0,0.02)'
                                        }}
                                        contentStyle={{
                                            fontSize: '15px',
                                            color: '#262626'
                                        }}
                                    >
                                    <Descriptions.Item label="Name">
                                        {user.name}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="User Id">
                                        {user.userId}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Email">
                                        {user.email}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Phone Number">
                                        {user.phone}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Department">
                                        {user.unit?.department?.value}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Unit">
                                        {user.unit?.value}
                                    </Descriptions.Item>
                                    <Descriptions.Item span={2} label="Roles">
                                    <div style={{display: "flex", flexWrap: "wrap", gap: "8px"}}>
                                        {user?.userRoles?.map(e => (
                                            <Tag
                                                key={Math.random()}
                                                style={{
                                                    marginBottom: "5px",
                                                    background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    padding: '6px 12px',
                                                    fontSize: '13px',
                                                    boxShadow: '0 2px 4px rgba(82,196,26,0.25)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    transition: 'all 0.3s ease'
                                                }}
                                            >
                                                <span>{`${e.role.replace(/_/g, " ").toLowerCase()}(${!e.scope ? 'global' : e.scope.toLowerCase()})`}</span>
                                            </Tag>
                                        ))}
                                    </div>
                                    </Descriptions.Item>
                                    </Descriptions>
                                </div>
                                <Divider style={{margin: "24px 0", borderColor: 'rgba(0,0,0,0.06)'}}/>

                                <div style={{
                                    display: 'flex',
                                    gap: '16px',
                                    flexWrap: 'wrap',
                                    marginTop: '24px',
                                    justifyContent: 'center'
                                }}>
                                    <Button
                                        type="primary"
                                        onClick={handleOpenModal}
                                            style={{
                                                background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                                                border: 'none',
                                                borderRadius: '8px',
                                                height: '44px',
                                                padding: '0 24px',
                                                boxShadow: '0 4px 12px rgba(24,144,255,0.35)',
                                                transition: 'all 0.3s ease',
                                                fontSize: '15px'
                                            }}
                                            onMouseEnter={e => {
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 6px 16px rgba(24,144,255,0.45)';
                                            }}
                                            onMouseLeave={e => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(24,144,255,0.35)';
                                            }}
                                    >
                                        <BsKey style={{marginRight: '0.5em'}}/>
                                        Change Password
                                    </Button>
                                    <Upload
                                        showUploadList={false}
                                        customRequest={handleSignatureUpload}
                                        beforeUpload={(file) => {
                                            const isImage = file.type.startsWith('image/') && file.type.includes("png");
                                            if (!isImage) {
                                                message.error(`${file.name} is not a png image file`);
                                                return false;
                                            }
                                            return true
                                        }}
                                    >
                                        <Button
                                            type="primary"
                                            style={{
                                                background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
                                                border: 'none',
                                                borderRadius: '8px',
                                                height: '44px',
                                                padding: '0 24px',
                                                boxShadow: '0 4px 12px rgba(82,196,26,0.35)',
                                                transition: 'all 0.3s ease',
                                                fontSize: '15px'
                                            }}
                                            onMouseEnter={e => {
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 6px 16px rgba(82,196,26,0.45)';
                                            }}
                                            onMouseLeave={e => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(82,196,26,0.35)';
                                            }}
                                        >
                                            <EditOutlined/>
                                            Change Signature
                                        </Button>
                                    </Upload>
                                    <Button
                                        type="primary"
                                        onClick={()=>setPrevShow(true)}
                                            style={{
                                                background: 'linear-gradient(135deg, #fa8c16 0%, #d46b08 100%)',
                                                border: 'none',
                                                borderRadius: '8px',
                                                height: '44px',
                                                padding: '0 24px',
                                                boxShadow: '0 4px 12px rgba(250,140,22,0.35)',
                                                transition: 'all 0.3s ease',
                                                fontSize: '15px'
                                            }}
                                            onMouseEnter={e => {
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 6px 16px rgba(250,140,22,0.45)';
                                            }}
                                            onMouseLeave={e => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(250,140,22,0.35)';
                                            }}
                                    >
                                        <EyeOutlined/>
                                        Preview Signature
                                    </Button>
                                </div>

                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
            <Modal
                title={
                    <div style={{
                        fontSize: '22px',
                        fontWeight: 600,
                        background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        padding: '8px 0'
                    }}>
                        Change Password
                    </div>
                }
                open={isOpen}
                onCancel={handleModalClose}
                footer={null}
                style={{ top: '20%' }}
                width={440}
                bodyStyle={{
                    padding: '32px',
                    background: 'linear-gradient(145deg, #ffffff, #f8f9fa)',
                }}
            >
                <Form layout="vertical">
                    <Form.Item
                        label={<span style={{ fontSize: '15px', fontWeight: 500 }}>Current Password</span>}
                        style={{ marginBottom: '20px' }}
                    >
                        <Input.Password
                            ref={oldPasswordRef}
                            placeholder="Enter your current password"
                            size="large"
                            style={{
                                borderRadius: '8px',
                                border: '1px solid rgba(0,0,0,0.1)',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label={<span style={{ fontSize: '15px', fontWeight: 500 }}>New Password</span>}
                        style={{ marginBottom: '20px' }}
                    >
                        <Input.Password
                            ref={newPasswordRef}
                            placeholder="Enter your new password"
                            size="large"
                            style={{
                                borderRadius: '8px',
                                border: '1px solid rgba(0,0,0,0.1)',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label={<span style={{ fontSize: '15px', fontWeight: 500 }}>Confirm Password</span>}
                        style={{ marginBottom: '32px' }}
                    >
                        <Input.Password
                            ref={confirmPasswordRef}
                            placeholder="Confirm your new password"
                            size="large"
                            style={{
                                borderRadius: '8px',
                                border: '1px solid rgba(0,0,0,0.1)',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
                            }}
                        />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button
                            type="primary"
                            onClick={handleUpdatePassword}
                            size="large"
                            block
                            style={{
                                background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                                border: 'none',
                                borderRadius: '8px',
                                height: '44px',
                                fontSize: '16px',
                                boxShadow: '0 4px 12px rgba(24,144,255,0.35)',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 6px 16px rgba(24,144,255,0.45)';
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(24,144,255,0.35)';
                            }}
                        >
                            <SyncOutlined style={{ marginRight: '8px' }}/>
                            Update Password
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                open={isPrevShow}
                onCancel={()=>setPrevShow(false)}
                title={
                    <div style={{
                        fontSize: '22px',
                        fontWeight: 600,
                        background: 'linear-gradient(135deg, #fa8c16 0%, #d46b08 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        padding: '8px 0'
                    }}>
                        Preview Signature
                    </div>
                }
                footer={null}
                width={560}
                style={{ top: '20%' }}
                bodyStyle={{
                    padding: '32px',
                    background: 'linear-gradient(145deg, #ffffff, #f8f9fa)',
                }}
            >
                <div style={{
                    background: 'white',
                    padding: '32px',
                    borderRadius: '12px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                    border: '1px solid rgba(0,0,0,0.04)'
                }}>
                    <Image
                        src={sig}
                        alt="signature"
                        height={200}
                        width={400}
                        style={{
                            objectFit: 'contain',
                            borderRadius: '8px'
                        }}
                    />
                </div>
            </Modal>
        </>
    )
}
